import { CheckMark, Deduct } from '@components/atoms';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { cn } from '@utils';
import * as React from 'react';

const Checkbox = React.forwardRef<
	React.ElementRef<typeof CheckboxPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
		indeterminate?: boolean;
	}
>(({ className, indeterminate, ...props }, ref) => (
	<CheckboxPrimitive.Root
		ref={ref}
		className={cn(
			'ring-offset-background focus-visible:ring-ring peer h-5 w-5 shrink-0 rounded-xs bg-bgFields transition-all focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed data-[state=checked]:text-primary data-[state=indeterminate]:text-primary data-[state=unchecked]:disabled:bg-bgFieldsDisabled data-[state=checked]:disabled:opacity-50',
			className
		)}
		{...props}
	>
		<CheckboxPrimitive.Indicator className={cn(' flex h-full w-full items-center justify-center text-current')}>
			{indeterminate ? <Deduct className="h-4 w-4" /> : <CheckMark className="h-4 w-4" />}
		</CheckboxPrimitive.Indicator>
	</CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
